import { render } from "./JobList.vue?vue&type=template&id=5c013290&ts=true"
import script from "./JobList.vue?vue&type=script&lang=ts"
export * from "./JobList.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__